import { useSearchParams } from 'react-router-dom'

/**
 * Tab state synced to the `?tab=` search param so settings tabs are
 * deep-linkable (old standalone routes redirect into these params).
 */
export function useSettingsTab(defaultTab: string) {
  const [searchParams, setSearchParams] = useSearchParams()
  const tab = searchParams.get('tab') ?? defaultTab

  const setTab = (value: string) => {
    const next = new URLSearchParams(searchParams)
    if (value === defaultTab) {
      next.delete('tab')
    } else {
      next.set('tab', value)
    }
    setSearchParams(next, { replace: true })
  }

  return [tab, setTab] as const
}
